import { STINT_STATUS_CHOICES } from 'utils';

import { ALLOWED_UPCOMING_STINT_STATUSES } from '../constants';

export const getUpcomingStintAllowedStatuses = () =>
  STINT_STATUS_CHOICES.filter(({ id }) => {
    return ALLOWED_UPCOMING_STINT_STATUSES.includes(id);
  });
